import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const LeaveRequestsIndexLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'LeaveRequestsIndex' */ './components/LeaveRequestsIndex'
		)
);

export default (store) => {
	return {
		index: true,
		element: <AsyncLoading component={<LeaveRequestsIndexLazy />} />,
	};
};
